import axios from "axios";

const http = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

export const api = {
  me: () => http.get("/auth/me").then((r) => r.data),
  createSession: (session_id) => http.post("/auth/session", { session_id }).then((r) => r.data),
  otpRequest: (email) => http.post("/auth/otp/request", { email }).then((r) => r.data),
  otpVerify: (email, code) => http.post("/auth/otp/verify", { email, code }).then((r) => r.data),
  logout: () => http.post("/auth/logout"),
  deleteAccount: (b) => http.post("/account/delete", b).then((r) => r.data),
  state: () => http.get("/state").then((r) => r.data),
  addVisited: (b) => http.post("/visited", b),
  patchVisited: (id, b) => http.patch(`/visited/${id}`, b),
  delVisited: (id) => http.delete(`/visited/${id}`),
  addWish: (b) => http.post("/wishlist", b),
  patchWish: (id, b) => http.patch(`/wishlist/${id}`, b),
  delWish: (id) => http.delete(`/wishlist/${id}`),
  reorder: (ids) => http.put("/wishlist/reorder", { ids }),
  addGoal: (b) => http.post("/goals", b),
  patchGoal: (id, b) => http.patch(`/goals/${id}`, b),
  delGoal: (id) => http.delete(`/goals/${id}`),
  reorderGoals: (ids) => http.put("/goals/reorder", { ids }),
  setTop5: (items) => http.put("/top5", { items }),
  share: () => http.get("/share").then((r) => r.data.token),
  createSource: (b) => http.post("/sources", { kind: "story", ...b }).then((r) => r.data),
  channelSources: () => http.get("/sources/channels").then((r) => r.data),
  sendFeedback: (b) => http.post("/feedback", b).then((r) => r.data),
  adminFeedback: () => http.get("/admin/feedback").then((r) => r.data),
  setFeedbackStatus: (id, status) => http.patch(`/admin/feedback/${id}`, { status }).then((r) => r.data),
  joined: () => http.get("/joined").then((r) => r.data),
  atlasStatus: () => http.get("/integrations/atlas").then((r) => r.data),
  atlasCreateKey: () => http.post("/integrations/atlas/key").then((r) => r.data.key),
  atlasRevokeKey: () => http.delete("/integrations/atlas/key"),
  pushKey: () => http.get("/push/key").then((r) => r.data),
  pushSubscribe: (sub) => http.post("/push/subscribe", sub),
  pushUnsubscribe: (endpoint) => http.post("/push/unsubscribe", { endpoint }),
  pushTest: () => http.post("/push/test").then((r) => r.data),
  calendarLink: () => http.get("/calendar/link").then((r) => r.data),
  calendarLinkCreate: () => http.post("/calendar/link").then((r) => r.data),
  calendarLinkStop: () => http.delete("/calendar/link"),
  card: () => http.get("/card").then((r) => r.data),
  saveCard: (b) => http.put("/card", b).then((r) => r.data),
  swapToken: () => http.post("/swap/token").then((r) => r.data),
  swapInfo: (t) => http.get(`/swap/${t}`).then((r) => r.data),
  swapAccept: (t) => http.post(`/swap/${t}/accept`).then((r) => r.data),
  sticker: () => http.get("/sticker").then((r) => r.data),
  resetSticker: () => http.post("/sticker/reset").then((r) => r.data),
  stickerCard: (fmt) => http.get(`/sticker/card.${fmt}`, { responseType: "blob" }).then((r) => r.data),
  tapInfo: (t) => http.get(`/tap/${t}`).then((r) => r.data),
  tapRequest: (t) => http.post(`/tap/${t}/request`).then((r) => r.data),
  inviteContact: (b) => http.post("/contacts/invite", b).then((r) => r.data),
  lookupLocation: (b) => http.post("/location/lookup", b).then((r) => r.data),
  addContact: (b) => http.post("/contacts", b).then((r) => r.data),
  addPersonPlace: (b) => http.post("/contacts/person/places", b).then((r) => r.data),
  mergePerson: (b) => http.post("/contacts/person/merge", b).then((r) => r.data),
  splitPerson: (b) => http.post("/contacts/person/split", b).then((r) => r.data),
  watchPeople: (b) => http.post("/people/watch", b).then((r) => r.data),
  matchPeople: (b) => http.post("/people/match", b).then((r) => r.data),
  setLocation: (b) => http.post("/location", b).then((r) => r.data),
  stopLocation: () => http.delete("/location"),
  friendLocations: () => http.get("/friend-locations").then((r) => r.data),
  views: () => http.get("/views").then((r) => r.data),
  adminUsers: () => http.get("/admin/users").then((r) => r.data),
  adminDeleteUser: (id) => http.delete(`/admin/users/${id}`),
  adminStats: () => http.get("/admin/stats").then((r) => r.data),
  sourceStats: () => http.get("/sources/stats").then((r) => r.data),
  visit: (b) => http.post("/visits", b).catch(() => null),
  visitSignup: (b) => http.post("/visits/signup", b).catch(() => null),
  shareInfo: () => http.get("/share").then((r) => r.data),
  setHandle: (handle) => http.put("/handle", { handle }).then((r) => r.data.handle),
  regenerateShare: () => http.post("/share/regenerate").then((r) => r.data.token),
  publicState: (token) => http.get(`/public/${token}`).then((r) => r.data),
  searchCities: (country, q) => http.get("/cities/search", { params: { country, q } }).then((r) => r.data),
  topCities: (country, offset, limit) => http.get("/cities/top", { params: { country, offset, limit } }).then((r) => r.data),
  friends: () => http.get("/friends").then((r) => r.data),
  follow: (token) => http.post("/friends", { token }).then((r) => r.data),
  friend: (id) => http.get(`/friends/${id}`).then((r) => r.data),
  unfollow: (id) => http.delete(`/friends/${id}`),
  followers: () => http.get("/followers").then((r) => r.data),
  followBack: (id) => http.post(`/followers/${id}/follow-back`).then((r) => r.data),
  requestTrip: (wish_id) => http.post("/trip-requests", { wish_id }).then((r) => r.data),
  myTripRequest: (wishId) => http.get(`/trip-requests/by-wish/${wishId}`).then((r) => r.data),
  saveTripForm: (id, f) => http.put(`/trip-requests/${id}/form`, f).then((r) => r.data),
  addTripNote: (id, text) => http.post(`/admin/trip-requests/${id}/notes`, { text }).then((r) => r.data),
  deleteTripNote: (id, noteId) => http.delete(`/admin/trip-requests/${id}/notes/${noteId}`).then((r) => r.data),
  setFollowUp: (id, follow_up) => http.put(`/admin/trip-requests/${id}/follow-up`, { follow_up }).then((r) => r.data),
  tripRequests: () => http.get("/admin/trip-requests").then((r) => r.data),
  setTripStatus: (id, status) => http.patch(`/admin/trip-requests/${id}`, { status }).then((r) => r.data),
  people: (q) => http.get("/people", { params: { q } }).then((r) => r.data),
  friendRequests: () => http.get("/friend-requests").then((r) => r.data),
  sendRequest: (user_id) => http.post("/friend-requests", { user_id }).then((r) => r.data),
  requestByLink: (token) => http.post("/friend-requests/by-link", { token }).then((r) => r.data),
  respondRequest: (id, accept) => http.post(`/friend-requests/${id}/respond`, { accept }).then((r) => r.data),
  cancelRequest: (id) => http.delete(`/friend-requests/${id}`),
  settings: () => http.get("/settings").then((r) => r.data),
  saveSettings: (b) => http.put("/settings", b).then((r) => r.data),
  notifications: () => http.get("/notifications").then((r) => r.data),
  notificationsSeen: () => http.post("/notifications/seen"),
  plans: () => http.get("/plans").then((r) => r.data),
  invite: (country, friend_id) => http.post("/plans", { country, friend_id }).then((r) => r.data),
  respondPlan: (id, accept) => http.post(`/plans/${id}/respond`, { accept }),
  patchPlan: (id, b) => http.patch(`/plans/${id}`, b),
  addPlanNote: (id, text) => http.post(`/plans/${id}/notes`, { text }),
  delPlanNote: (id, noteId) => http.delete(`/plans/${id}/notes/${noteId}`),
  leavePlan: (id) => http.delete(`/plans/${id}/leave`),
};

export const shareUrl = (token) => `${(process.env.REACT_APP_PUBLISHED_URL || window.location.origin).replace(/\/$/, "")}/share/${token}`;

const site = () => (process.env.REACT_APP_PUBLISHED_URL || window.location.origin).replace(/\/$/, "");
export const shortUrl = (handle) => `${site()}/${handle}`;
export const joinUrl = (handle) => `${site()}/join/${handle}`;
export const cardUrl = (handle) => `${site()}/api/u/${handle}`;

export const withSource = (link, code) => (code ? `${link}${link.includes("?") ? "&" : "?"}s=${code}` : link);
export const visitorId = () => {
  let v = localStorage.getItem("bl_vid");
  if (!v) { v = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`; localStorage.setItem("bl_vid", v); }
  return v;
};
